import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Cta from '@/components/base/Cta'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { imageParagraph } from './animations'
import { cn } from '@/lib/utils'
import { WPLink, WPPageData } from '@/types'

export type SimpleParagraphProps = HTMLAttributes<HTMLElement> &
  Partial<{
    paragraph: {
      alignment: 'left' | 'right'
      pretitle: string
      title: string
      title_component: TypographyProps['component']
      paragraph: string
      button: WPLink
    }
    theme: WPPageData['acf']['theme']
  }>

const SimpleParagraph = ({
  paragraph,
  theme,
  ...props
}: SimpleParagraphProps) => {
  return (
    <Motion animation={imageParagraph}>
      {(motionRef) => (
        <section
          ref={motionRef}
          {...props}
          className={cn([
            {
              'bg-dark-100 text-dark-500': theme === 'light',
              'bg-dark-600 text-white': theme === 'dark'
            }
          ])}
        >
          <Container>
            <Grid>
              {paragraph ? (
                <div
                  className={cn([
                    'col-span-4 flex flex-col gap-[1.6rem]',
                    'md:col-span-6',
                    'lg:col-span-5 lg:gap-[3.2rem]',
                    { 'lg:col-start-2': paragraph.alignment === 'left' },
                    { 'lg:col-start-7': paragraph.alignment === 'right' }
                  ])}
                >
                  {paragraph.pretitle ? (
                    <Typography
                      variant="label"
                      className="font-extrabold"
                      data-motion-pretitle
                    >
                      {paragraph.pretitle}
                    </Typography>
                  ) : null}
                  {paragraph.title ? (
                    <Typography
                      variant="h3"
                      className="!font-normal [&_strong]:font-bold"
                      component={paragraph.title_component}
                      data-motion-title
                    >
                      {paragraph.title}
                    </Typography>
                  ) : null}
                  {paragraph.paragraph ? (
                    <Typography variant="body" data-motion-paragraph>
                      {paragraph.paragraph}
                    </Typography>
                  ) : null}
                  {paragraph.button ? (
                    <Cta
                      link={paragraph.button}
                      theme="light"
                      data-motion-cta
                    />
                  ) : null}
                </div>
              ) : null}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default SimpleParagraph
